export default __webpack_public_path__ + "static/media/ACKNOWLEDGEMENT OF RECEIPT.8bce9028.pdf";